var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoSmGyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "info-sm-gy-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.577,
    height: 17.577,
    viewBox: "0 0 17.577 17.577",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-info-circle",
    "data-name": "Icon awesome-info-circle",
    d: "M9.351.563A8.789,8.789,0,1,0,18.14,9.351,8.79,8.79,0,0,0,9.351.563Zm0,3.9A1.488,1.488,0,1,1,7.863,5.949,1.488,1.488,0,0,1,9.351,4.461Zm1.985,9a.425.425,0,0,1-.425.425H7.792a.425.425,0,0,1-.425-.425v-.851a.425.425,0,0,1,.425-.425h.425V9.918H7.792a.425.425,0,0,1-.425-.425V8.642a.425.425,0,0,1,.425-.425H10.06a.425.425,0,0,1,.425.425v3.544h.425a.425.425,0,0,1,.425.425Z",
    transform: "translate(-0.563 -0.563)",
    fill: "#6d6d6d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoSmGyIcon);
export default __webpack_public_path__ + "static/media/info-sm-gy-icon.b71e6ae8847b9ce75a1526e31c8f8d72.svg";
export { ForwardRef as ReactComponent };